<template>
  <div class="card-line-info">
    <div :class="['header-title',
    {'active-mini-title' : item?.miniTitle }]">
      <num-title>
        {{ item.title }}
      </num-title>
      <mini-title v-if="item?.miniTitle">
        {{ item.miniTitle }}
      </mini-title>
    </div>
    <main-paragraph class="purple-grey-title">
      {{ item.text }}
    </main-paragraph>
  </div>
</template>

<script>
import NumTitle from "@/components/shared/text/NumTitle.vue";
import MainParagraph from "@/components/shared/text/MainParagraph.vue";
import MiniTitle from "@/components/shared/text/MiniTitle.vue";

export default {
  name: "CardLineInfo",
  components: {MiniTitle, MainParagraph, NumTitle},
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .card-line-info {
    display: flex;
    flex-direction: column;
    border-left-color: var(--color-orange);
    border-left-style: solid;


    .header-title {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
    }
  }

  @media (max-width: 3024px){
    .card-line-info {
      padding-left: 32px;
      border-left-width: 4px;

      .header-title {
        column-gap: 8px;
        &.active-mini-title {
          margin-bottom: 12px;
          .text-content {
            margin-bottom: -12px;
          }
        }
      }
    }
  }


  @media (max-width: 1920px) {
    .card-line-info {
      padding-left: 20px;
      border-left-width: 4px;

      .header-title {
        column-gap: 8px;
        &.active-mini-title {
          margin-bottom: 9px;
          .text-content {
            margin-bottom: -9px;
          }
        }
      }
    }
  }
  @media (max-width: 1600px) {
    .card-line-info {
      padding-left: 10px;
      border-left-width: 2px;

      .header-title {
        column-gap: 8px;
        &.active-mini-title {
          margin-bottom: 9px;
          .text-content {
            margin-bottom: -9px;
          }
        }
      }
    }
  }
  @media (max-height: 800px) {
    .card-line-info {
      padding-left: 8px;
      border-left-width: 1px;

      .header-title {
        column-gap: 8px;
        &.active-mini-title {
          margin-bottom: 7px;
          .text-content {
            margin-bottom: -7px;
          }
        }
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {

    .card-line-info {
      padding-left: 10px;
      border-left-width: 2px;

      .header-title {
        column-gap: 8px;
        &.active-mini-title {
          margin-bottom: 9px;
          .text-content {
            margin-bottom: -9px;
          }
        }
      }
    }
  }

  @media (max-width: 1133px) {
    .card-line-info {
      padding-left: 8px;
      border-left-width: 1px;

      .header-title {
        column-gap: 8px;
        &.active-mini-title {
          margin-bottom: 7px;
          .text-content {
            margin-bottom: -7px;
          }
        }
      }
    }
  }
  @media (max-width: 769px) {
    .card-line-info {
      padding-left: 10px;
      border-left-width: 2px;
      justify-content: center;

      .purple-grey-title {
        font-size: 14px;
      }
      .header-title {
        column-gap: 8px;
        &.active-mini-title {
          margin-bottom: 9px;
          .text-content {
            margin-bottom: -9px;
          }
        }
      }
    }
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .card-line-info {
      padding-left: 40px;
      border-left-width: 8px;

      .header-title {
        column-gap: 16px;
        &.active-mini-title {
          margin-bottom: 23px;
          .text-content {
            margin-bottom: -23px;
          }
        }

      }
    }
  }

</style>